module.exports = __webpack_public_path__ + "static/media/stream_logo.0e081aae.svg";